import { DataBean } from "../DataBean";

export class FixedAssetOrderConcept extends DataBean {


    public async getFixedAssetOrderConceptCatalog(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetOrderConceptCatalog_Number", [id]);
    }
}